export default {
  state: {
    signUpSchema: {},
    submittedForm: {},
    submittedFormResponse: {},
    completed: false,
  }
}
